import InputField from "components/fields/InputField";
import { FcGoogle } from "react-icons/fc";
import Checkbox from "components/checkbox";
import { useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/store";
import AuthService from "services/AuthService";
import { v4 as uuid } from 'uuid';
import { login } from "store/user/userSlice";
import UserService from "services/UserService";
import { Navigate, useNavigate } from "react-router-dom";


 

export default function SignIn() {
const {user} = useSelector((state:RootState)=>state);
const navigate = useNavigate();
  const dispatch = useDispatch();
  const [userName,setUserName] = useState('');
    const [userPassword,setUserPasssword] = useState('');
    async function handleEnterLogin(usernm:string,password:string) {
        await UserService.loginUser(dispatch,usernm,password).then(()=>{
          navigate("/admin")
        });
    }




  return (
    <div className="mt-16 mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
      {/* Sign in section */}
      <div className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
        <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
          Sign In
        </h4>
        <p className="mb-9 ml-1 text-base text-gray-600">
          Enter your login and password to sign in!
        </p>
      
        <div className="mb-6 flex items-center  gap-3">
          <div className="h-px w-full bg-gray-200 dark:bg-navy-700" />
        </div>
        {/* Email */}
        <InputField
          variant="auth"
          extra="mb-3"
          label="Login*"
          placeholder="Login"
          id="login"
          type="text"
          value = {userName}
          onchange={(e:any)=>setUserName(e.target.value)}
        />

        {/* Password */}
        <InputField
          variant="auth"
          extra="mb-3"
          label="Password*"
          placeholder="Min. 8 characters"
          id="password"
          type="password"
          value = {userPassword}
          onchange={(e:any)=>setUserPasssword(e.target.value)}
        />
        {/* Checkbox */}
        {/* <div className="mb-4 flex items-center justify-between px-2">
          <div className="flex items-center">
            <Checkbox />
            <p className="ml-2 text-sm font-medium text-navy-700 dark:text-white">
              Keep me logged In
            </p>
          </div>
          <a
            className="text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
            href=" "
          >
            Forgot Password?
          </a>
        </div> */}
        <button
        onClick={()=>handleEnterLogin(userName,userPassword)}
         className="linear mt-2 w-full rounded-xl
          bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200">
          Sign In
        </button>
        {/* <div className="mt-4">
          <span className=" text-sm font-medium text-navy-700 dark:text-gray-600">
            Not registered yet?
          </span>
          <a
            href=" "
            className="ml-1 text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
          >
            Create an account
          </a>
        </div> */}
      </div>
    </div>
  );
}
